import { createFileRoute, Link } from "@tanstack/react-router";
import { faqBreadcrumbJsonLd, faqJsonLd, faqRouteHead } from "@/lib/faq-seo";
import { jsonLdScript } from "@/lib/marketing-jsonld";
import { FAQ_PAGE, FAQ_SECTIONS } from "@/content/marketing";
import { Faq } from "@/components/landing/Faq";

// Head/meta AND structured data for this route are owned by
// `src/lib/faq-seo.ts` — a route module may only export components, so keeping
// the JSON-LD there is also what makes it directly assertable in a test.
export const Route = createFileRoute("/_home/faq")({
  ssr: true, // public SEO route (D-216-5)
  head: faqRouteHead,
  component: FaqPage,
});

function FaqPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdScript(faqJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdScript(faqBreadcrumbJsonLd) }}
      />
      <nav aria-label="Breadcrumb" className="sr-only">
        <ol>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li aria-current="page">FAQ</li>
        </ol>
      </nav>
      {/* Top-level landmark so assistive tech can skip the nav (#416); the
          layout's SiteFooter is a sibling, so contentinfo survives. */}
      <main>
        <Faq title={FAQ_PAGE.title} sections={FAQ_SECTIONS} headingLevel="h1" />
      </main>
    </>
  );
}
